<template>
  <div>
    <task-header></task-header>
    <task-content></task-content>
  </div>
</template>
<script>
import Header from './Task/Header'
import Content from './Task/Content'
import { mapGetters } from 'vuex'
import axios from 'axios'
import { PBN_SET, TASK_SET } from '../../../store/mutation-types'

export default {
  mounted () {
    this.loadTask()
  },
  computed: {
    ...mapGetters({
      task: 'getTask',
      filters: 'getFilters'
    })
  },
  components: {
    taskHeader: Header,
    taskContent: Content
  },
  methods: {
    loadTask () {
      axios.get(`/maintenance/task/${this.$route.params.id}`)
        .then(r => {
          this.$store.commit(TASK_SET, r.data)
          document.title = this.task.title + ' :: Task :: PBN360 by Aphex Media'
          axios.get(`/pbn/site/${this.task.pbn.punyDomain}`)
            .then(r => {
              this.$store.commit(PBN_SET, r.data)
            })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/MaintenanceOrder/Task.vue